/**
 * @fileoverview Keeps the document's theme in step with the route.
 *
 * The theme is a preference that applies only behind a sign-in; every public
 * path is dark. The boot script in index.html settles the FIRST paint, and
 * this settles every client-side navigation after it — signing out onto the
 * landing page, opening /pricing from Settings, finishing the login and
 * arriving on the dashboard. Renders nothing; mount it once inside the router.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { syncThemeToRoute } from "@/lib/theme";

export default function ThemeRouteSync() {
  const { pathname } = useLocation();
  useEffect(() => {
    syncThemeToRoute(pathname);
  }, [pathname]);
  return null;
}
